/***
 * 单选接口获取数据
 */

import React from 'react';
import { getData } from '@util';
import { Select } from 'antd';

class SingleSelect extends React.PureComponent {
  state = {
    AddCodeData: [],
  };

  componentDidMount() {
    this.getAddCodeFunc();
  }

  getAddCodeFunc = () => {
    const { api } = this.props;
    getData({
      api: api,
    }).then(res => {
      const { result } = res;
      this.setState({
        AddCodeData: [...result],
      });
    });
  };

  render() {
    const { AddCodeData } = this.state;
    return (
      <Select
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        showSearch
        placeholder={'请选择'}
        {...this.props}>
        {AddCodeData.map(item => (
          <Select.Option key={item.code} value={item.code}>
            {item.code}
            {item.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default SingleSelect;
